
import * as gqlTypes from "@hydrologiq/gql/graphql"
import type { AttributeConfig } from "../../types"

export const baseNoteConfig: AttributeConfig = {
    attribute: gqlTypes.ActivityAttributeKind.Note,
    label: "Note",
    visibility: "visible",
    editable: true,
    required: false,
    validator: () => ({ valid: true }), // Optional field
    order: 90, // Default order
    defaultValue: (ctx) => {
        return ctx.activity.attributes?.find((attr) => attr.attribute === gqlTypes.ActivityAttributeKind.Note && attr.event_kind === ctx.eventKind)?.value ?? null
    },
}